import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { useNavigate } from "react-router-dom";
import { message } from "antd";

export const useAddAdminMutation = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("BETTY_ADMIN_USER_TOKEN");

  return useMutation({
    mutationFn: (payload: any) => {
      const updatedPayload = {
        ...payload,
        phoneCountryCode: payload?.phoneNumber?.slice(0, 4),
        phoneNumber: payload?.phoneNumber?.slice(4),
      };

      return axiosInstance
        .post("/admins/add-admin", updatedPayload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res: any) => res.data);
    },
    onSuccess: async (data: any) => {
      message.success(data?.message);
      navigate("/admin-management");
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.message);
    },
  });
};
